(() => {
  const handles = new Set([
    'the-best-rave-pashmina',
    'the-best-rave-outfit-ideas',
    'what-to-wear-to-lost-lands-music-festival',
    'what-to-bring-to-a-rave'
  ]);
  const articlePath = window.location.pathname.replace(/\/$/, '');
  const articleHandle = articlePath.split('/').pop();
  if (!handles.has(articleHandle) || !articlePath.startsWith('/blogs/news/')) return;
  if (window.scummyBlogCommerceTrackingBound) return;
  window.scummyBlogCommerceTrackingBound = true;

  const cleanText = value => (value || '').replace(/\s+/g, ' ').trim().slice(0, 100);

  const analyticsAllowed = () => {
    const privacy = window.Shopify?.customerPrivacy;
    if (typeof privacy?.analyticsProcessingAllowed !== 'function') return false;
    return privacy.analyticsProcessingAllowed() === true;
  };

  const placementFor = link => {
    if (link.dataset.placement) return cleanText(link.dataset.placement);
    if (link.closest('[data-rave-pashmina-module]')) return 'artist_product_module';
    if (link.closest('.sb-editorial-product-grid, .sb-rave-product-grid')) return 'product_module';
    let element = link;
    while (element && !element.classList.contains('article__rte')) {
      let sibling = element.previousElementSibling;
      while (sibling) {
        if (sibling.matches('h2, h3')) return cleanText(sibling.textContent);
        sibling = sibling.previousElementSibling;
      }
      element = element.parentElement;
    }
    return 'article_body';
  };

  document.addEventListener('click', event => {
    if (event.button && event.button !== 0) return;
    const link = event.target?.closest?.('.article__rte a[href]');
    if (!link) return;
    const rawHref = link.getAttribute('href');
    if (!rawHref || rawHref.startsWith('#')) return;
    let destination;
    try {
      destination = new URL(rawHref, window.location.href);
    } catch {
      return;
    }
    if (!['https:', 'http:'].includes(destination.protocol)) return;
    if (!['www.scummybears.com', 'scummybears.com'].includes(destination.hostname)) return;

    const destinationPath = destination.pathname.replace(/\/$/, '');
    const pathParts = destinationPath.split('/').filter(Boolean);
    let eventName;
    if (pathParts[0] === 'products' || (pathParts[0] === 'collections' && pathParts[2] === 'products')) {
      eventName = 'blog_product_click';
    } else if (pathParts[0] === 'collections' && pathParts.length === 2) {
      eventName = 'blog_collection_click';
    } else if (pathParts[0] === 'blogs' && pathParts.length === 3) {
      eventName = 'blog_article_click';
    } else {
      return;
    }

    try {
      if (!analyticsAllowed() || typeof window.gtag !== 'function') return;
      window.gtag('event', eventName, {
        send_to: 'G-EVDL66KQFJ',
        article_handle: articleHandle,
        content_group: 'scene_damage',
        destination_path: destinationPath,
        link_text: cleanText(link.querySelector('strong')?.textContent || link.textContent),
        placement: placementFor(link),
        transport_type: 'beacon'
      });
    } catch {}
  });
})();
